export const ROUTES = {
	ERROR: '*',
	HOME: '/',
	LOGIN: '/login',
	BUY_SELL: '/buy-sell-crypto',
	REGISTER: '/register',
};
